<template>
    <div class="header pl-3 pt-2 pb-1 pr-3">
        <div class="b-header rounded overflow-hidden bSecondary shadow-def-sm">
            <div class="container">
                <img class="icon" src="../../assets/favicon.png" />
                <h4 class="app-name tPrimary">
                    Routine Manager
                    <span class="beta aPrimary">ADMIN</span>
                </h4>
                <b-button
                    @click="reFreshDatas()"
                    variant="outline-info"
                    size="sm"
                    class="float-right mt-1"
                >
                    <i class="fa fa-refresh"></i> Refresh
                </b-button>
                <b-button
                    @click="changeTheme(!isDark)"
                    variant="outline-info"
                    size="sm"
                    class="float-right mt-1 mr-2"
                >Change</b-button>
            </div>
            <div class="progress bSecondary" v-bind:class="{animate:isLoading}">
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
/** IMPORTS */
import { bus } from "../../main";
import { mapActions, mapGetters, mapMutations } from "vuex";

/** COMPONENTS */

export default {
    name: "Header",
    methods: {
        ...mapActions(["fetchStudents", "reFreshDatas"]),
        ...mapMutations(["changeTheme"]),
        onClickLogout() {
            bus.$emit("LogoutAdmin");
        }
    },
    computed: {
        ...mapGetters(["isLoading", "isDark"])
    }
};
</script>
<style lang="scss" scoped>
.header {
    position: relative;
    height: 4.5rem;
    // background-color: #2e3c42;
    .icon {
        float: left;
        height: 2.2rem;
        cursor: pointer;
    }
    .app-name {
        letter-spacing: 1px;
        font-weight: 400;
        user-select: none;
        float: left;
        cursor: pointer;
        padding-top: 0.2rem;
        margin-left: 1rem;
    }
    .beta {
        font-size: 0.6rem;
    }
    .b-header {
        position: relative;
        height: 100%;
        padding: 0.7rem;
    }
    .progress {
        display: block;
        height: 2px;
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        span {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgb(37, 156, 146);
        }
    }
    .animate {
        span {
            display: block;
            width: 50%;
            animation: progress_anim 1s linear infinite;
        }
    }
}
@keyframes progress_anim {
    0% {
        width: 0%;
        left: 0;
    }
    50% {
        left: 0;
        width: 50%;
    }
    100% {
        width: 10%;
        left: 90%;
    }
}
.SignedIn {
    float: right;
    margin-top: 1rem;
    .lead {
        float: left;
    }
    .btn {
        float: right;
        margin-left: 1rem;
    }
}
</style>
